import React from 'react';

export interface IdleTimerDebugPanelProps {
  idleTimeRemaining: number;
  idleTimeDisplaySeconds: number;
  modalIsOpen: boolean;
  modalTimeRemaining: number;
  onClose: () => void;
}

const IdleTimerDebugPanel: React.FC<IdleTimerDebugPanelProps> = ({
  idleTimeRemaining,
  idleTimeDisplaySeconds,
  modalIsOpen,
  modalTimeRemaining,
  onClose,
}) => {
  return (
    <div
      style={{
        position: 'fixed',
        bottom: 20,
        right: 20,
        backgroundColor: '#f5f5f5',
        border: '2px solid #333',
        borderRadius: '8px',
        padding: '12px',
        fontSize: '12px',
        fontFamily: 'monospace',
        zIndex: 10000,
        maxWidth: '300px',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
      }}
    >
      <div style={{ marginBottom: '8px', fontWeight: 'bold' }}>
        🔍 Idle Timer Debug
      </div>
      <div>Idle Time: {idleTimeRemaining}s / {idleTimeDisplaySeconds}s</div>
      <div>Modal Open: {modalIsOpen ? '✓ Yes' : '✗ No'}</div>
      {modalIsOpen && (
        <div style={{ color: '#d32f2f', fontWeight: 'bold' }}>
          Auto-logout: {modalTimeRemaining}s
        </div>
      )}
      <div style={{ marginTop: '8px' }}>
        <button
          onClick={onClose}
          style={{
            fontSize: '10px',
            padding: '4px 8px',
            cursor: 'pointer',
            backgroundColor: '#fff',
            border: '1px solid #ccc',
            borderRadius: '4px',
          }}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default IdleTimerDebugPanel;
